


































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { UAParser } from 'ua-parser-js';
import { SystemService, IDevice } from '../api/system-service';
import { authState } from '@/store/modules/auth-state';

@Component
export default class Home extends Vue {
  serialLoading: boolean = false;

  deauthorizeDialog: boolean = false;

  alert: boolean = false;

  alertMessage: string = '';

  devices: IDevice[] = []

  serial: string = '';

  async mounted() {
    document.title = process.env.VUE_APP_TITLE;

    try {
      this.serialLoading = true;
      if (await SystemService.authenticate()) {
        // 認証済みであればログインしておく
        authState.login();
        this.goNavi();
      }
      this.serialLoading = false;
    } catch (error) {
      this.alert = true;
      this.alertMessage = 'サーバーに接続できませんでした。';
      console.error(this.alertMessage, error);
    }

    console.log(document.cookie);
  }

  async registrate() {
    let deviceName: string = '';

    this.serialLoading = true;

    // Windows 10
    // Mac OS 10.15.2
    // Android 9 (Sony G8441)
    // iOS 13.3 (Apple iPad)
    const parser = new UAParser();
    const os = parser.getOS();
    deviceName = `${os.name} ${os.version}`;
    const device = parser.getDevice();
    if (device.vendor) {
      deviceName += ` (${device.vendor} ${device.model})`;
    }
    console.log('DeviceName', deviceName);

    const result = await SystemService.register(this.serial, deviceName);
    this.serialLoading = false;
    switch (result.code) {
      case 'OK':
        // 正常に登録された
        authState.login();
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect as string);
        } else {
          this.goNavi();
        }
        break;
      case 'MAX_DEVICES_COUNT':
        // 台数を超えている場合
        this.showDevice();
        break;
      case 'NOT_FOUND':
        this.alert = true;
        this.alertMessage = 'シリアルキーが存在しません。';
        break;
      case 'EXPIRED':
        this.alert = true;
        this.alertMessage = 'シリアルキーの期限が切れています。';
        break;
      default:
        this.alert = true;
        this.alertMessage = 'サーバーに接続できませんでした。';
    }
  }

  async showDevice() {
    this.deauthorizeDialog = true;
    this.devices = await SystemService.getDevices(this.serial);
  }

  async unregister(deviceID: string) {
    console.log('deviceID', deviceID);
    try {
      if (await SystemService.unregister(this.serial, deviceID)) {
        // 項目から削除する
        this.devices = this.devices.filter((item => item.rowKey !== deviceID));

        this.deauthorizeDialog = false;
        await this.registrate();
      }
    } catch (error) {
      this.alert = true;
      this.alertMessage = 'サーバーに接続できませんでした。';
      console.error(this.alertMessage, error);
    }
  }

  goNavi() {
    this.$router.push({ name: 'navi' });
  }

  formatTime(time: Date): string {
    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const ret = `${year}/${month}/${day}`;
    return ret;
  }
}
